import React from 'react';
import { useCookies } from 'react-cookie';

import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import { useStyles } from './styles';

const COOKIE_NAME = 'cookies-user-consent';
const COOKIE_EXPIRATION = 31536000;

const CookieBanner = () => {
	const classes = useStyles();
	const [cookies, setCookie] = useCookies();

	const onAcceptPolicy = React.useCallback(() => {
		setCookie(COOKIE_NAME, cookies[COOKIE_NAME] ? { ...cookies[COOKIE_NAME], userConsent: true } : { userConsent: true }, {
			maxAge: COOKIE_EXPIRATION,
			sameSite: 'none',
			secure: true
		});
	}, [cookies, setCookie]);

	return cookies[COOKIE_NAME]?.userConsent ? null : (
		<Paper className={classes.root} elevation={6} id="cookiesBannerContainer">
			<Grid container justifyContent="space-evenly" alignItems="center" direction="row">
				<Grid item xs={7} sm={8} md={10} className={classes.content}>
					<Typography className={classes.text}>
						This website uses cookies to enable site functional, attendance reporting as well as platform usage data on an aggregate
						basis. If you would like to know more about our cookie policy, please read our{' '}
						<a className={classes.legalLink} href="https://www.launchmetrics.com/galleries-privacy-notice">
							privacy
						</a>{' '}
						and{' '}
						<a className={classes.legalLink} href="https://www.launchmetrics.com/galleries-cookies-policy">
							cookies
						</a>{' '}
						policies
					</Typography>
				</Grid>
				<Grid item xs={5} sm={4} md={2} className={classes.content}>
					<Button id="acceptCookiesButton" className={classes.button} onClick={onAcceptPolicy}>
						Close
					</Button>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default React.memo(CookieBanner);
